import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import CategorizedPermissionsDisplay from "../CategorizedPermissionsDisplay";

const categorizePermissions = (permissions) => {
  const readPermissions = [];
  const writePermissions = [];

  Object.entries(permissions).forEach(([key, value]) => {
    if (value === "write") {
      writePermissions.push(key);
    } else if (value === "read") {
      readPermissions.push(key);
    }
  });

  return { readPermissions, writePermissions };
};

const GitHubOrgAppDetailsView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {entityData?.github_org_app_data?.permissions &&
        (() => {
          const { readPermissions, writePermissions } = categorizePermissions(
            entityData.github_org_app_data.permissions
          );
          return (
            <CategorizedPermissionsDisplay
              readPermissions={readPermissions}
              writePermissions={writePermissions}
              maxWidth={300}
            />
          );
        })()}
      {entityData?.github_org_app_data?.access_file_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Access File</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            {entityData?.github_org_app_data?.access_file_name &&
              entityData?.github_org_app_data?.access_file_permissions && (
                <>
                  <TextIntegrationStyle
                    title={""}
                    value={
                      entityData?.github_org_app_data?.access_file_name +
                      ": " +
                      entityData?.github_org_app_data?.access_file_permissions
                    }
                  ></TextIntegrationStyle>
                </>
              )}
          </Box>
        </Box>
      )}
      {entityData?.github_org_app_data?.repositories_count && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Repositories</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
            <TextIntegrationStyle
              title={""}
              value={entityData.github_org_app_data.repositories_count}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.github_org_app_data && (
        <>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Suspended</Typography>
            </Box>
            <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
              <TextIntegrationStyle
                title={""}
                value={
                  entityData.github_org_app_data.suspended_at ? "True" : "False"
                }
              ></TextIntegrationStyle>
            </Box>
          </Box>
          {/* Fixed value for all org apps */}
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Target</Typography>
            </Box>
            <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
              <TextIntegrationStyle
                title={""}
                value={"Organization"}
              ></TextIntegrationStyle>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};

export default GitHubOrgAppDetailsView;
